import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import React from 'react';

const LoadError = () => (
  <FuelFlex
    defaultProps={{
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      customMargin: `${dsTheme.spacing.km16} 0 0`,
    }}
    testId="search-load-error-state"
  >
    <FuelTypography size="heading-sm" weight="bold" tag="h4" color="neutral-strong">
      Falha ao carregar a busca
    </FuelTypography>
  </FuelFlex>
);

export default LoadError;
